import Loading from "./Loading";

const DashboardWidget = ({height = 140, onClick, style, loading = false, ...props}) => {

    return (
        <div className="dashboard-widget"
             style={{height: height, cursor: onClick ? "pointer" : "default", ...style}}
             onClick={onClick}>
            <div className="dashboard-widget-content">
                {!loading && props.children}
                {loading && <Loading/>}
            </div>
        </div>
    )


}

export default DashboardWidget;
